<template>
 <div>请关闭当前页面...</div>
</template>

<script type="text/javascript">

export default {
    components: {},
    props: {},
    data() {
        return {}
    },
    methods: {
    },
    computed: {
    },
    created() {
    },
    mounted() {
        window.opener=null; 
        window.open('','_self');
        window.close();
    },
    watch: {}
}
</script>

<style type="text/css" scoped>

</style>



// WEBPACK FOOTER //
// src/views/Layout/Close.vue